// Silence verbose console.log/.info/.debug in production builds (incl. Railway
// dev — both build with NODE_ENV=production). Keeps error/warn. Local `npm start`
// is unaffected. Imported FIRST (side-effect on import) so it applies before
// other modules' init logs.
import './lib/silenceConsole';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext';
import { installAuthFetch } from './lib/installAuthFetch';

// Force rebuild timestamp: 2025-11-25T06:20:00Z

installAuthFetch();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
